// Shared UI Library Components
import { CustomIcon, EIconName } from "@ppmcore/seven-ppm-core-shared-components-react";

export const CProfilePageMenuList = [
  {
    label: 'Personal Data',
    path: `profile-settings`,
    icon: <CustomIcon name={ EIconName.PersonOff }/>,
    activeIcon: <CustomIcon name={ EIconName.PersonOn }/>
  },
  {
    label: 'Change Password',
    path: 'profile-settings/change-password',
    icon: <CustomIcon name={ EIconName.Lock }/>,
    activeIcon: <CustomIcon name={ EIconName.LockFill }/>
  },
  {
    label: 'Change Email',
    path: 'profile-settings/change-email',
    icon: <CustomIcon name={ EIconName.Mail }/>,
    activeIcon: <CustomIcon name={ EIconName.Mail }/>
  },
  {
    label: 'Notification Settings',
    path: 'profile-settings/notification-settings',
    icon: <CustomIcon name={ EIconName.EditNotificationOff }/>,
    activeIcon: <CustomIcon name={ EIconName.EditNotificationOn }/>
  },
  // {
  //   label: 'Delete Account',
  //   path: 'profile-settings/delete-account',
  //   icon: <CustomIcon name={ EIconName.DeleteAccount }/>,
  //   activeIcon: <CustomIcon name={ EIconName.DeleteAccountFill }/>
  // },
];
